import styled from 'styled-components';
import { SVGProps } from 'react';

const ProcessingIconStyled = styled.svg`
  > .c-cog-a,
  > .c-cog-b {
    transform-origin: 512px 640px;
    animation: fluent-processing-icon-spin 10s linear infinite;
  }
  > .c-cog-b {
    transform-origin: 1472px 1344px;
    animation-direction: reverse;
  }

  &.is-paused > .c-cog-a,
  &.is-paused > .c-cog-b {
    animation-play-state: paused;
  }

  @keyframes fluent-processing-icon-spin {
    to {
      transform: rotate(1turn);
    }
  }
`;

export default function SpinningProcessingIcon({
  paused,
  ...props
}: SVGProps<SVGSVGElement> & { paused?: boolean }) {
  // fluent-ui Processing icon
  return (
    <ProcessingIconStyled
      {...props}
      className={`${props.className || ''} ${paused ? 'is-paused' : ''}`}
      viewBox="0 0 2048 2048"
    >
      <path
        className="c-cog-a"
        d="M837 844q-23 37-53 67t-68 54l51 124-118 48-51-123q-40 10-86 10t-86-10l-51 123-118-48 51-124q-37-23-67-53t-54-68L63 895 15 777l123-51q-10-40-10-86t10-86L15 503l48-118 124 51q46-75 121-121l-51-124 118-48 51 123q40-10 86-10t86 10l51-123 118 48-51 124q75 46 121 121l124-51 48 118-123 51q10 40 10 86t-10 86l123 51-48 118-124-51zm-325 52q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20z"
        fill="currentColor"
      />
      <path
        className="c-cog-b"
        d="M1920 1344q0 55-14 111l137 56-48 119-138-57q-59 98-156 156l57 137-119 49-56-137q-56 14-111 14t-111-14l-56 137-119-49 57-137q-98-58-156-156l-138 57-48-119 137-56q-14-56-14-111t14-111l-137-56 48-119 138 57q58-97 156-156l-57-138 119-48 56 137q56-14 111-14t111 14l56-137 119 48-57 138q97 59 156 156l138-57 48 119-137 56q14 56 14 111zm-448 320q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25z"
        fill="currentColor"
      />
    </ProcessingIconStyled>
  );
}
